export default __webpack_public_path__ + "static/media/flaticon.bb8da269.woff2";